import React from 'react';

import StudentDetails from './StudentDetails';
import StudentSubjects from './StudentSubjects';

import { StudentInfoContainer } from './StudentInfo.style';

/**
 *  Opakowanie danych dotyczących widoku wyników wyszukiwania, występuje tu podział na szczegóły znajdujące się po lewej stronie oraz tabelę przedmiotów.
 *
 */
const StudentInfo = (): JSX.Element => {
  return (
    <StudentInfoContainer>
      <StudentDetails />
      <StudentSubjects />
    </StudentInfoContainer>
  );
};

export default StudentInfo;
